import React from "react";
import _ from 'lodash';

import { 
    Row,
    Col,
    Form,
    Spinner,
    Button,
} from "react-bootstrap-v5";

import { DrawerContentLayout } from '../../../components/drawer/DrawerLayout'
import Utils from "../../../utils/utils";
import { ReportUOM } from "../../../utils/enums";

import RSuiteSelectPicker from '../../../components/OLD/Select/RSuiteSelectPicker';

import { connect } from 'react-redux'
import { clear } from "../../../../setup/redux/actions";
import { dispatchApiCallGet } from '../../../../setup/redux/dispatch/actions'


class VehiclesForm extends React.Component {
  
    constructor(props) {
        super(props);
    
        this.bodyRef = React.createRef();

        let dataParams = (props.dataParams) ? props.dataParams : null;
        let id = (dataParams && dataParams.id) ? dataParams.id : null;
        let row = (dataParams && dataParams.row) ? dataParams.row : null;
        
        this.state = {
            id: id,
            row: row,
        };
    }


    componentWillReceiveProps(nextProps) {
        this.reduxProps(nextProps);
    }


    /* API */
    reduxProps = nextProps => {
        Utils.reduxProps(nextProps,
            'vehicle_form_drawer-default_driver', 
            (data, isLoading, isError, err, statusCode, variables, callback) => {
                let arr = variables.items;

                if(data && data.data && data.data.length > 0) {
                    for (var i = 0; i < data.data.length; i++) {
                        let item = data.data[i];
                        let value = item.driverId;
                        let title = item.driverName;
                        let arrItem = {
                            value: value,
                            title: title,
                            item: item,
                        };

                        arr = Utils.addToArray(arr, value, arrItem);
                    }
                }

                this.setState({
                    isLoading: isLoading,
                    isError: isError,
                    err: err,
                }, () => {
                    this.props.clear();

                    if(callback){
                        callback(arr);
                    }
                });
            }
        );
    }
	
    callReadDefaultDriverApi = (items, callback = null) => {
        let data = {
            currentPage: 1,
            pageSize: Utils.getMaxPageSize(),
            searchQuery: '',
        };
     
        this.props.dispatchApiCallGet(data, 'vehicle_form_drawer-default_driver', 'driver', { items: items }, callback, () => {});
    }
    /* END API */


    body = () => {
        let {
            handleChange,
            setFieldValue,
            validateForm,
            values,
            errors,
        } = this.props.formOptions;
        
        return <Row>
            
            <Col xs={12}>
                <Form.Group className={'mb-5'}>
                    <Form.Label>{this.props.fields.vehicleName.label}</Form.Label>
                    <Form.Control
                        type="text"
                        id={this.props.fields.vehicleName.id}
                        placeholder={this.props.fields.vehicleName.placeholder}
                        value={values.vehicleName}
                        onChange={handleChange}
                        isInvalid={!!errors.vehicleName}
                    />
                    <Form.Control.Feedback type="invalid">{errors.vehicleName}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group className={'mb-5'}>
                    <Form.Label>{this.props.fields.defaultDriverId.label}</Form.Label>
                    <Form.Control
                        as = {RSuiteSelectPicker}
                        isInvalid={!!errors.defaultDriverId}

                        id={this.props.fields.defaultDriverId.id}
                        placeholder={this.props.fields.defaultDriverId.placeholder}
                        items={values.customFormParams.defaultDriverItems}
                        value={values.defaultDriverId}
                        selectedName={values.defaultDriverName}
                        isLoading={values.customFormParams.defaultDriverIsLoading}
                        searchable={true}
                        cleanable={true}
                        isDefault={true}
                        onClick={async () => {
                            await setFieldValue('customFormParams.defaultDriverIsLoading', true);
                            this.callReadDefaultDriverApi(values.customFormParams.defaultDriverItems, async (items) => {
                                await setFieldValue('customFormParams.defaultDriverItems', items);
                                await setFieldValue('customFormParams.defaultDriverIsLoading', false);
                            });
                        }}
                        onSelect={async (value, item) => {
                            await setFieldValue('defaultDriverId', value);
                            await setFieldValue('defaultDriverName', item.title);
                        }}
                        onClear={async () => {
                            await setFieldValue('defaultDriverId', null);
                            await setFieldValue('defaultDriverName', '');
                        }}
                    />
                    <Form.Control.Feedback type="invalid">{errors.defaultDriverId}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group className={'mb-5'}>
                    <Form.Label>{this.props.fields.unladednBinWeight.label} {(values.uom === ReportUOM.kg) ? '(kg)' : '(tons)'}</Form.Label>
                    <Form.Control
                        type="number"
                        id={this.props.fields.unladednBinWeight.id}
                        placeholder={this.props.fields.unladednBinWeight.placeholder}
                        value={values.unladednBinWeight}
                        onChange={handleChange}
                        isInvalid={!!errors.unladednBinWeight}
                    />
                    <Form.Control.Feedback type="invalid">{errors.unladednBinWeight}</Form.Control.Feedback>
                </Form.Group>
            </Col>

        </Row>
    }
    
    footer = () => {
        let {
            validateForm,
            values,
        } = this.props.formOptions;

        return <Row>
            <Col xs={'auto'}>
                <Button 
                    type={'submit'}
                    disabled={this.props.isLoading}
                >
                    SAVE
                    {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                </Button>
            </Col>
            <Col xs={'auto'}>
                <Button 
                    type={'button'}
                    variant={'secondary'}
                    disabled={this.props.isLoading}
                    onClick={() => {
                        Utils.showDrawer(this.props.drawer, false);
                    }}
                >
                    CANCEL
                    {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                </Button>
            </Col>
            
            
            {values.isEdit && <>
                <Col xs={12} className={'d-flex d-sm-none pb-3'}></Col>
                <Col xs={'auto'} sm={true} className={'text-end'}>
                    <Button 
                        type={'button'}
                        variant={'danger'}
                        disabled={this.props.isLoading}
                        onClick={() => {
                            if(this.props.onDelete){
                                this.props.onDelete(values);
                            }
                        }}
                    >
                        REMOVE
                        {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                    </Button>
                </Col>
                <Col xs={'auto'} md={'auto'}>
                    <Button 
                        type={'button'}
                        variant={'outline-secondary'}
                        disabled={this.props.isLoading}
                        onClick={() => {
                            validateForm().then((err) => {
                                if(_.isEmpty(err)){
                                    if(this.props.onCopy){
                                        this.props.onCopy(values);
                                    }
                                } else {
                                    Utils.toast('You must fill in the required fields', 'error');
                                }
                            })
                        }}
                    >
                        <i className={'material-icons'}>content_copy</i>
                        COPY
                        {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                    </Button>
                </Col>
            </>}

        </Row>
    }


    render() {
        return <DrawerContentLayout
            ref={this.bodyRef}
            isBlocking={this.props.isBlocking}
            body={this.body()}
            footer={this.footer()}
        />
    }
}

const mapDispatchToProps = {
  dispatchApiCallGet,
  clear,
}

export default connect(Utils.mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(VehiclesForm);
